import firebase from 'firebase'
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCLXjYwUkvEWkzsB8fyObgLH0E8oMv7VXU",
  authDomain: "betaqa10-d0f84.firebaseapp.com",
  projectId: "betaqa10-d0f84",
  storageBucket: "betaqa10-d0f84.appspot.com",
  messagingSenderId: "803816362419",
  appId: "1:803816362419:web:f01b7c16f4d33b7f5bbbc6"
};
const firebaseApp=firebase.initializeApp(firebaseConfig);
const db=firebase.firestore();
const storage = firebase.storage();

export default { firebaseApp, db, storage};